import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../Assets/Css/MapMedicine.css";
import backIcon from "../../Assets/Images/Expand_left.png";
import Med1 from "../../Assets/Images/Med1.png";
import Med2 from "../../Assets/Images/Med2.png";
import Med3 from "../../Assets/Images/Med3.png";

const MapMedicine = () => {
  const navigate = useNavigate();
  const medicines = [
    { id: 1, name: "Medicine 1", image: Med1 },
    { id: 2, name: "Medicine 2", image: Med2 },
    { id: 3, name: "Medicine 3", image: Med3 },
  ];

  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [currentMedicineName, setCurrentMedicineName] = useState("");
  const [updatedMedicineNames, setUpdatedMedicineNames] = useState({});

  const openPopup = (medicine) => {
    setSelectedMedicine(medicine);
    setCurrentMedicineName("");
    setPopupOpen(true);
  };

  const handleSave = () => {
    setUpdatedMedicineNames((prev) => ({
      ...prev,
      [selectedMedicine.id]: currentMedicineName,
    }));
    setPopupOpen(false);
  };

  const handleMainnavigate = () => {
    navigate("/daily-regimen");
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="hmap-medicine-container">
      <div className="header">
        <button className="back-button" onClick={handleBackClick}>
          <img src={backIcon} alt="Back" className="back-icon" />
        </button>
        <h1>Map Medicine</h1>
      </div>
      <div className="map-medicine-container">
        <div className="mmedicine-list">
          {medicines.map((medicine) => (
            <div key={medicine.id}>
              <p className="mmedicine-name">{medicine.name}</p>
              <div className="mmedicine-item">
                <img
                  src={medicine.image}
                  alt={medicine.name}
                  className="medicine-image"
                />
                <div className="medicine-info">
                  <button
                    className="select-button"
                    onClick={() => openPopup(medicine)}
                    style={{
                      color: updatedMedicineNames[medicine.id]
                        ? "#FBB03B"
                        : "inherit",
                      border: updatedMedicineNames[medicine.id]
                        ? "1.5px solid green"
                        : "1.5px solid transparent",
                    }}
                  >
                    {updatedMedicineNames[medicine.id] || "Select"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button className="save-button" onClick={handleMainnavigate}>
          Save
        </button>
      </div>

      {popupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button
              className="close-popup"
              onClick={() => setPopupOpen(false)}
            >
              &times;
            </button>
            <h4 className="pop-heading">{selectedMedicine?.name}</h4>
            <img
              src={selectedMedicine?.image}
              alt={selectedMedicine?.name}
              className="medicine-popup-image"
            />
            <select
              className="popup-select"
              value={currentMedicineName}
              onChange={(e) => setCurrentMedicineName(e.target.value)}
            >
              <option value="">Select</option>
              <option value="Metformin">Metformin</option>
              <option value="Paracetamol">Paracetamol</option>
              <option value="Amlodipine">Amlodipine</option>
            </select>
            <button className="popup-save-button" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapMedicine;
